
import { AmmunitionStockEvent } from './ammunition-stock-event.model';
import { ComposedRowsEntityDecorator, EntityDecorator } from '@scisys-uim/uim-common';


export abstract class AmmunitionStockEventRowsEntityDecoratorBase<G> extends ComposedRowsEntityDecorator<AmmunitionStockEvent, number, G> {
  constructor(rowTypeDecorator: EntityDecorator<AmmunitionStockEvent, number>, 
    groupTypeDecorator: EntityDecorator<any, G>) {
    super(rowTypeDecorator, groupTypeDecorator);
  }
}



